import { FC } from "react";

import { Header } from "../../../components/header";
import { Charts, StatsList } from "./components";

const DashboardPage: FC = () => {
  return (
    <>
      <Header />
      <div style={{ padding: 15 }}>
        <StatsList />
        <Charts />
      </div>
    </>
  );
};

export default DashboardPage;
